import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-badminton-championship',
  templateUrl: './badminton-championship.component.html',
  styleUrls: ['./badminton-championship.component.scss']
})
export class BadmintonChampionshipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
